import {Injectable} from '@angular/core';
import {AbstractControl, ValidationErrors} from '@angular/forms';
import isNumber from 'is-number';

@Injectable({
  providedIn: 'root'
})
export class DWPValidatorsService {

  constructor() {
  }

  dateWithinDaysInThePast(subject, numberOfDaysInThePast: number): boolean {
    try {
      subject.getTime();
    } catch (e) {
      subject = new Date(Date.parse(subject));
      if (!subject) {
        return false;
      }
    }
    const now = new Date();
    const dateInThePast: Date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0);
    dateInThePast.setDate(dateInThePast.getDate() - numberOfDaysInThePast);
    const todayAt2359 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59);
    const valid = subject.getTime() >= dateInThePast.getTime() && subject.getTime() <= todayAt2359.getTime();

    return valid;
  }

  dateWithinDaysInTheFuture(subject, numberOfDaysInTheFuture): boolean {
    try {
      subject.getTime();
    } catch (e) {
      subject = new Date(Date.parse(subject));
      if (!subject) {
        return false;
      }
    }

    const dateInTheFuture: Date = new Date();
    dateInTheFuture.setDate(dateInTheFuture.getDate() + numberOfDaysInTheFuture);
    const now = new Date();
    const todayAt0000 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0);
    const valid = subject.getTime() <= dateInTheFuture.getTime() && subject.getTime() >= todayAt0000.getTime();
    return valid;
  }

  number(value: { value } | AbstractControl): ValidationErrors {
    return !value.value || isNumber(value.value) ? null : {error: 'INVALID NUMBER'};
  }

  notBlank(value: { value } | AbstractControl): ValidationErrors {
    return value.value && value.value.toString().trim().length > 0 || value && value.value === 0 ? null : {error: 'Required'};
  }

  notEmpty(value: AbstractControl): ValidationErrors {
    return value.value && value.value.length > 0 ? null : {error: 'Required'};
  }


  date(value: { value } | AbstractControl): ValidationErrors {

    function validDate(subject): boolean {
      if (!subject) {
        return false;
      }
      if (isNumber(subject)) {
        return false;
      }

      try {
        subject.getTime();
      } catch (e) {

        try {
          const date = new Date(Date.parse(subject));

          if (!isNumber(date.getDate())) {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
      return true;
    }

    if (!value) {
      return {value: 'please-enter-a-valid-date'};
    }
    return validDate(value.value) ? null : {error: 'please-enter-a-valid-date'};
  }

  isDateEqualOrBefore(primary: string, secondary: string): boolean {
    return this.compareDates(primary, secondary) <= 0;
  }


  isDateEqualOrAfter(primary: string, secondary: string): boolean {
    return this.compareDates(primary, secondary) >= 0;
  }

  isDateBefore(primary: string, secondary: string): boolean {
    return this.compareDates(primary, secondary) < 0;
  }

  compareDates(primary: string, secondary: string): number {
    const d1 = new Date(primary);
    const d2 = new Date(secondary);

    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    if (d1.getTime() === d2.getTime()) {
      return 0;
    }

    if (d1 > d2) {
      return 1;
    }

    if (d1 < d2) {
      return -1;
    }
  }
}
